module.exports = __webpack_public_path__ + "static/img/discount.0729a67.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/discount.png
// module id = 83
// module chunks = 0